import { Component } from '@angular/core';

@Component({
  selector: 'iq-spinner',
  templateUrl: 'spinner.component.html',
  styleUrls: ['spinner.component.scss']
})
export class SpinnerComponent {}
